let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4I43M")).then(() => parcelRequire('8hRh5'));